import { useStmBrandStore } from './use-stm-brand-store'

export const useStmCampaignCode = () => {
  const { currentBrand } = useStmBrandStore()

  return {
    campaignCode: currentBrand?.campaignCode ?? null,
    campaignId: currentBrand?.campaignId ?? null,
    projectCode: currentBrand?.projectCode ?? null,
    countryCode: currentBrand?.countryCode ?? null,
  }
}
